import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select, { ValueType } from 'react-select';
import { applicationOptions } from '../../stores/applications/selectors';
import { groupOptions, groupOptionsPerWorkspace } from '../../stores/groups/selectors';
import { RootState } from '../../stores/store';
import MultiSelect from '../common/MultiSelect';

interface Props extends LocalizeContextProps {
    selected: string[];
    groups: Array<{ label: string, value: string }>;
    selection?: ValueType<{ label: string, value: string }> | null;
    updateSelection: (selection: ValueType<{ label: string, value: string }>) => void;
    filterPerWorkspace: boolean;
}

class GroupSelect extends React.Component<Props> {
    public componentDidMount() {
        this.props.updateSelection(
            this.props.groups.filter((group) =>
                this.props.selected.find((id) => group.value === id))
        );
    }

    public render() {
        const t = this.props.translate;
        return (
          <React.Fragment>
            <MultiSelect
              className={"dropdown-select group-multiselect group-select"}id={"group-multiselect"}
              options={this.props.groups.sort((a, b) => {
                if (a.label.toLowerCase() < b.label.toLowerCase()) {
                  return -1;
                } else {
                  return 1;
                }
              })}
              value={this.props.selection}
              onChange={this.handleSelectChange}
            />
          </React.Fragment>
        );
    }

    private handleSelectChange = (val?: ValueType<{ label: string, value: string }>) => {
        this.props.updateSelection((val === null || val === undefined) ? [] : val);
    }
}

const mapStateToProps = (state: RootState, props: { filterPerWorkspace : boolean}) => {
  if(props.filterPerWorkspace){
    return {groups: groupOptionsPerWorkspace(state)}
  }else{
    return {groups: groupOptions(state)}
  }
}

export default connect(mapStateToProps)(withLocalize(GroupSelect));